import request from '@/utils/request'

let projectApi = {
  /*项目列表*/
  projectList(data, errorback) {
    return request._post('/shop/plus.project.Project/index', data, errorback);
  },
  /*添加项目*/
  addProject(data, errorback) {
    return request._post('/shop/plus.project.Project/add', data, errorback);
  },
  getProjectData(data, errorback) {
    return request._get('/shop/plus.project.Project/add', data, errorback);
  },
  /*获取项目数据*/
  getProject(data, errorback) {
    return request._get('/shop/plus.project.Project/edit', data, errorback);
  },
  /*保存项目*/
  editProject(data, errorback) {
    return request._post('/shop/plus.project.Project/edit', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.project.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.project.Setting/getSetting', data, errorback);
  },
  /*删除项目*/
  deleteProject(data, errorback) {
    return request._post('/shop/plus.project.Project/delete', data, errorback);
  },
  /*获取项目分类*/
  getProjectType(data, errorback) {
    return request._post('/shop/plus.project.Project/getProjectType', data, errorback);
  },
   // 审核
 passCanel(data) {
  return request._post('/shop/plus.project.Project/passCanel', data);
},
     // 获取合作人员
  user(data) {
  return request._post('/shop/plus.project.Project/user', data);
},



  /*类型列表*/
  typeList(data, errorback) {
    return request._post('/shop/plus.project.Project/indexType', data, errorback);
  },
  /*添加类型*/
  addType(data, errorback) {
    return request._post('/shop/plus.project.Project/addType', data, errorback);
  },
  /*获取类型详情*/
  getType(data, errorback) {
    return request._get('/shop/plus.project.Project/editType', data, errorback);
  },
  /*保存类型*/
  editType(data, errorback) {
    return request._post('/shop/plus.project.Project/editType', data, errorback);
  },
    /*删除类型*/
    delType(data, errorback) {
      return request._post('/shop/plus.project.Project/delType', data, errorback);
    },
}
export default projectApi;



// WEBPACK FOOTER //
// ./src/api/project.js